module.exports = __webpack_public_path__ + "images/fa-start-learning-bg.jpg";